import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import PrintButton from '../../components/PrintButton';
import { Page } from '@eir/letter';
import LetterHead from '../../components/LetterHead';
import LetterFoot from '../../components/LetterFoot';
import { getOsaPolicyLetterService, useApiRequest } from '@eir/services';
import PolicyOverview from '../../components/PolicyOverview';

const RoadsideAssistanceCertificateView = () => {
  document.title = 'Veihjelpsbevis';

  const match = useRouteMatch('/rac/:policyId');
  const { loading, data, error } = useApiRequest(
    getOsaPolicyLetterService('KrakenAPI', match.params.policyId)
  );

  console.log(data);

  return (
    data && (
      <>
        <Wrapper>
          <Page
            pageHeader={<LetterHead fields={data.fields} />}
            pageFooter={<LetterFoot />}
            content={
              <ContentContainer>
                <h1>Veihjelpsbevis</h1>
                <PolicyOverview changePeriod={false} data={data} />
                <p
                  style={{
                    textAlign: 'center',
                    marginTop: '1rem',
                    fontWeight: 700,
                  }}
                >
                  Veihjelpsbeviset oppbevares sammen med vognkortet{' '}
                </p>
                <br />
                  <div
                  style={{
                    display: 'grid',
                    columnGap: '2.5rem',
                    rowGap: '0.75rem',
                    gridTemplateColumns: 'auto 1fr',
                  }}
                >
                  <p>Registreringsnummer</p>
                  <p>{data.fields.registrationNumber}</p>
                  <p>Løyvenummer</p>
                  <p>{data.fields.permitNumber}</p>
                  <p>Egenandel</p>
                  <p>Kr 750 pr skadetilfelle</p>
                  <p>Dekningsområde</p>
                  <p>Norden</p>
                  <p>Veihjelp dekker:</p>
                  <p></p>
                </div>
                <h3>Assistanse og transport av kjøretøy</h3>
                <p>
                  Utgifter til berging eller tauing av kjøretøy og tilhenger
                  erstattes ved skade, utelåsing, startproblemer eller
                  upåregnelig driftsstopp. Det samme gjelder ved driftsstopp
                  fordi kjøretøyet går tomt for drivstoff eller strøm.
                </p>
                <p>
                  Utgifter til transport til nærmeste verksted erstattes hvis
                  ikke reparasjon på stedet er rimeligere.
                </p>
                <p>
                  Nødvendige merutgifter til henting av kjøretøyet erstattes når
                  kjøretøyet er etterlatt av årsaker som nevnt ovenfor. Hvis
                  kjøretøyet hadde tilhenger erstattes merutgiftene til henting
                  av denne.
                </p>
                <p>
                  Erstatningen er begrenset til 50 prosent av kjøretøyets verdi
                  da skaden skjedde.
                </p>
                <h3>Persontransport</h3>
                <p>
                  Når kjøretøyet er skadet erstattes nødvendige merutgifter til
                  hjemreise for fører og passasjerer, inkludert bagasje.
                  Forutsetningen er at kjøretøyet er så alvorlig skadet at det
                  ikke kan settes i trafikksikker stand innen rimelig tid. Det
                  samme gjelder hvis kjøretøyet er stjålet og ikke er kommet til
                  rette innen rimelig tid. Utgifter til annet reisemål enn
                  hjemsted erstattes. Erstatningen kan ikke overstige
                  merutgiftene til hjemreise. Merutgiftene beregnes ut fra
                  rimeligste reisealternativ. Nødvendige merutgifter til
                  hjemtransport erstattes for passasjerer som ikke kan fortsette
                  reisen fordi føreren rammes av ulykkestilfelle, plutselig
                  sykdom eller død.{' '}
                </p>
                <div
                  style={{
                    textAlign: 'center',
                    marginTop: '2rem',
                    fontWeight: 700,
                  }}
                >
                  <p>Veihjelpen leveres av REDGO</p>
                  <p>Har du behov for assistanse?</p>
                  <p>Ring 9090 8415 – Tastevalg 3</p>
                </div>
              </ContentContainer>
            }
          />
        </Wrapper>
        <PrintButton />
      </>
    )
  );
};

export default RoadsideAssistanceCertificateView;

const Wrapper = styled.div`
  font-family: Poppins;
  width: 56.25rem;
  margin: 1.875rem auto;
  color: #7b7d8c;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;

  @media print {
    margin: 0;
    width: 100%;
  }

  h1 {
    font-weight: 700;
    font-size: 1.6rem;
    color: #32346a;
    background-color: #df492c;
    padding: 0 0.5rem;
    margin: 0.5rem 0;

    @media print {
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
      font-size: 14pt;
    }
  }

  h2 {
    color: #32346a;
    font-size: 1.2rem;

    @media print {
      font-size: 12pt;
    }
  }

  h3 {
    color: #32346a;
    font-size: 1rem;

    @media print {
      font-size: 10pt;
    }
  }

  p {
    line-height: 1.3;
    margin-bottom: 0.5rem;
    font-family: NotoSans;

    @media print {
      margin-bottom: 8pt;
      font-size: 10pt;
    }
  }
`;

const ContentContainer = styled.div`
  margin-top: 3rem;

  @media print {
    margin-top: 1cm;
  }
`;

const Strong = styled.p`
  font-weight: 700;
`;

const Disclaimer = styled.div`
  font-style: italic;
  font-size: 0.8rem;
`;

const NoWrap = styled.span`
  white-space: nowrap;
`;
